import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import MobileMenu from './MobileMenu'

export default function Header() {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  
  const navItems = [
    { path: '/artist', label: 'ARTIST' },
    { path: '/contacts', label: 'CONTACT' },
    { path: '/content', label: 'CONTENT' },
    { path: '/about', label: 'ABOUT US' }
  ]
  
  return (
    <>
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 flex items-center justify-between h-[68px] md:h-[100px]">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/logo-black.svg" 
              alt="Coupang Play Logo"
              className="h-5 md:h-auto"
              style={{
                width: '159.78px',
                height: '19.997px',
                aspectRatio: '159.78/20.00'
              }}
            />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative transition-colors ${
                  location.pathname === item.path
                    ? ''
                    : 'hover:text-black'
                }`}
                style={{
                  color: '#000',
                  textAlign: 'center',
                  fontFamily: 'Pretendard',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  lineHeight: '145%',
                  letterSpacing: '-0.08px',
                  textTransform: 'uppercase'
                }}
              >
                {item.label}
                {location.pathname === item.path && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-black"></span>
                )}
              </Link>
            ))}
          </nav>
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="md:hidden w-12 h-12 flex items-center justify-center"
            aria-label="Menu"
          >
            <img 
              src="/images/mobile-menu.svg" 
              alt="Menu"
              className="w-7 h-3"
            />
          </button>
        </div>
      </header>
      
      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)}
        navItems={navItems}
      />
    </>
  )
}
